import { type Properties } from 'posthog-js';
import { useEffect } from 'react';

import { type Whoami } from '@/types/whoami';

import { usePostHog } from './use-posthog';

const whoamiToIdentifyPropertyKeys = {
  email: 'email',
  first_name: 'firstname',
  last_name: 'lastname',
  external_id: 'hire_external_id',
  account_id: 'account_id',
  last_sign_in_at: 'last_login_hire',
  account_wx_external_id: 'company_uuid',
  wx_external_id: 'user_uuid',
  wx_audience_external_id: 'audience_uuid',
} as const;

export function usePostHogIdentify(whoami: Whoami | undefined | null): void {
  const posthog = usePostHog();
  useEffect(() => {
    /* eslint-disable-next-line no-underscore-dangle */
    if (!whoami?.external_id || posthog._isIdentified()) {
      return;
    }

    posthog.identify(whoami.external_id, identifyPropertiesFromWhoami(whoami));

    if (whoami.account_id) {
      posthog.group('account', whoami.account_id);
    }
  }, [posthog, whoami]);
}

function identifyPropertiesFromWhoami(whoami: Whoami): Properties {
  const properties: Properties = {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  Object.entries(whoamiToIdentifyPropertyKeys).forEach(
    ([whoamiKey, propertyKey]) => {
      if (typeof whoami[whoamiKey as keyof Whoami] === 'string') {
        properties[propertyKey] = whoami[whoamiKey as keyof Whoami];
      }
    },
  );

  return properties;
}
